import { tg } from "@/telegram/tg";
import { Landing } from "@/screens/Landing";
import { Privacy } from "@/screens/Privacy";
import { Flow } from "@/screens/Flow";
import { partnerApi } from "@/lib/api";
import { saveRefCode } from "@/lib/storage";

// Реферальная ссылка на сайт: ttex.online/?ref=CODE. Пользователь ещё не авторизован, поэтому
// код сохраняем локально — Flow отправит его на сервер, как только клиент опознан. Заодно
// отмечаем переход, чтобы у партнёра считалась статистика по ссылке.
// Выполняется РОВНО один раз за загрузку страницы: иначе повторный рендер (в т.ч. StrictMode)
// накрутил бы партнёру лишние переходы.
let refCaptured = false;
function captureRefCode() {
  if (refCaptured || typeof window === "undefined") return;
  refCaptured = true;
  const code = new URLSearchParams(window.location.search).get("ref");
  if (!code) return;
  saveRefCode(code);
  void partnerApi.checkCode(code).catch(() => undefined);
}

export default function App() {
  const path = typeof window !== "undefined" ? window.location.pathname.replace(/\/$/, "") : "";
  const insideTelegram = typeof window !== "undefined" && !!tg()?.initData;
  captureRefCode();
  const wantSupport =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("screen") === "support";
  const initialScreen = wantSupport ? "support" : undefined;
  if (path === "/privacy") return <Privacy />;
  if (insideTelegram) return <Flow initialScreen={initialScreen} />;
  if (path === "/app") return <Flow resetLabel="Выйти" initialScreen={initialScreen} />;
  return <Landing />;
}
